module.exports = __webpack_public_path__ + "img/media.5cd61785.png";